module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/notokr-regular.woff
// module id = rxkJ
// module chunks = 0